import { render, staticRenderFns } from "./Giftcard.vue?vue&type=template&id=026e31aa&scoped=true"
import script from "./Giftcard.vue?vue&type=script&lang=js"
export * from "./Giftcard.vue?vue&type=script&lang=js"
import style0 from "./Giftcard.vue?vue&type=style&index=0&id=026e31aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026e31aa",
  null
  
)

export default component.exports